export default function getDateFromString(str) {
  if (str) {
    const date = new Date(str);
    return date.toLocaleDateString('en-US');
  }
  return '';
}
